import React, { JSX } from 'react';
import EventStatusTransitionDialogFrame from './EventStatusTransitionDialogFrame';

type Props = {
  open: boolean;
  eventId: string;
  eventName?: string;
  subtitleOverride?: string;
  busy: boolean;
  onCancel: () => void;
  onProceed: () => void | Promise<void>;
};

export default function DistributionToRackingConfirmDialog(props: Props): JSX.Element | null {
  const { open, eventId, eventName, subtitleOverride, busy, onCancel, onProceed } = props;
  const titleName =
    (subtitleOverride?.trim() ? subtitleOverride.trim() : null) ||
    (eventName?.trim() ? eventName : eventId);

  return (
    <EventStatusTransitionDialogFrame
      open={open}
      busy={busy}
      onCancel={onCancel}
      onProceed={onProceed}
      titleId="distribution-to-racking-title"
      eyebrow="Race distribution"
      title="Move to Racking"
      subtitle={titleName}
      headerAccent="amber"
      warningTone="info"
      warningTitle="Before you proceed"
      warningBody={
        <>
          You are moving this race from <strong>Distribution</strong> to <strong>Racking</strong>. Confirm that
          devices handed out in the field have been scanned back in as retrieved before athletes rack their
          assigned units.
        </>
      }
      operationIntro={
        <p>
          In <span className="font-semibold text-gray-800 dark:text-slate-200">Racking</span>, operators verify
          rear and front device IDs against packaging assignments. You can move this race{' '}
          <strong>back to Distribution</strong> later if needed.
        </p>
      }
      confirmPhrase="RACKING"
      confirmInputId="distribution-to-racking-confirm-input"
      proceedButtonText="Proceed to Racking"
      proceedUseSuccessTone={false}
    />
  );
}
